<template>
  
  <div class="content">
    <b-navbar type="light" variant="light" sticky>
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
        </b-navbar-nav>
      </b-navbar>

    <div class="container-fluid">
      <h1>Modifier {{ $route.params.template }}</h1>

      <table>
      <tr v-for="string in strings" :key="string.key" >
        <td>{{ string.key }}</td>
        <td>
          <label-editable :resourcekey="string.key" :text="string.text"></label-editable>
        </td>
      </tr>
      </table>
    </div>

    <b-navbar type="light" variant="light">
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
        </b-navbar-nav>
      </b-navbar>

    <div id="context-menu" style="visibility: collapse;">
      <div id="bold">Bold</div>
      <div id="italic">Italic</div>
    </div>

  </div>
</template>
<style scoped>
  td {
    vertical-align: top;
    padding: 4pt;
  }
  tr:nth-child(even) {
      background-color: #E7E9EB;
  }
  tr:nth-child(odd) {
      background-color: #fdfeff;
  }
</style>

<style>

  ul.small li {
    font-size: 11px;
  }

  table.small tr {
    height: 10px;
  }
  table.small tr td {
    font-size: 10px;
    padding: 4px;
  }
  table.small tr th {
    font-size: 10px;
    padding: 4px;
    background-color:#d1d0d0;
  }
  
  table.small tr:nth-child(even) {background: #FFF}
  table.small tr:nth-child(odd)  {background: #CCC}

  table.medium tr {
    height: 12px;
  }
  table.medium tr td {
    font-size: 12px;
    padding: 4px;
  }
  table.medium tr th {
    font-size: 12px;
    padding: 4px;
    background-color:#d1d0d0;
  }
  
  table.medium tr:nth-child(even) {background: #FFF}
  table.medium tr:nth-child(odd)  {background: #CCC}

  table.large > tbody > tr {
    height: 40px;
  }

  table.large > tbody > tr:nth-child(even) {
    background: #EEE
  }

  table.large > tbody > tr > td {
    font-size: 14px;
    padding: 10px;
  }
  

  table.compact > tbody > tr {
    height: 10px !important;
  }

  table.compact > tbody > tr > td {
    padding-top:    1px !important;
    padding-bottom: 1px !important;
  }

  body{
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }

  .title0 {
    font-weight: bold;
    color: #800000;
    font-size: 17pt;
    text-align: center;
  }

  .title1 {
    font-weight: bold;
    color: #800000;
    font-size: larger;
  }

  .title2 {
    font-weight: bold;
    color: #9e1b1b;
    font-size: large;
  }

  tr    { page-break-inside:avoid; page-break-after:auto }

  body {
    margin-left: 15pt;
    margin-right: 15pt;
  }

  p {
    text-align: justify;
  }

  .callout {
    border-left: #800000;
    border-left-width: 2px;
    border-left-style: solid;
    padding-left: 8px;
    margin-left: -5px;
  }

</style>
<script>
  import common from '../common/pages.js'
        
  let contextMenu = undefined

  export default {
    data() {
      return {
        strings: {}
      }
    },
    methods: {
      ...common.methods,

    },  
    mounted() {
      contextMenu = document.getElementById("context-menu");

      this.$http.get('/admin/templatestrings?template='+this.$route.params.template)
      .then(response => {
        console.log("EditTemplate response", response.data)
        this.strings = response.data.strings

        /*setTimeout( ()=> {
          

          document.querySelectorAll("[contenteditable='true']").forEach(elem => elem.addEventListener("contextmenu", (event)=>{
            console.log("elem.offsetLeft", elem.offsetLeft)
            contextMenu.style.position = "absolute"
            contextMenu.style.display = "block";
            contextMenu.style.left = (event.pageX - elem.offsetLeft) + 'px' //event.clientX + "px";
            contextMenu.style.top = event.clientY + 'px' //event.pageY + "px";
          }))

          // Hide the context menu when the user clicks outside of it
          document.addEventListener("click", (event) => {
            if (event.target !== contextMenu ) {
              contextMenu.style.display = "none";
            }
          });
        })

        // Prevent the default context menu from appearing
        document.addEventListener("contextmenu", (event) => {
          event.preventDefault();
        });
      }, 1000);*/
  
      });

  
    }
  }
</script>